module.exports = __webpack_public_path__ + "img/stripe_americanexpress_light.52ad483a.png";